module.exports = __webpack_public_path__ + "assets/166dc850711e11f4c712aa225d97d648.jpg";